import styled, {css} from "styled-components";

export const SelectModalStyled = css`
    .transfer-select-modal {
        .ant-modal-body {
            height: 60vh;
            padding: 0;
        }
    }
`;

export const Styled = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;

  .row-1 {
    padding: 12px 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 6%);
  }

  .row-2 {
    flex: 1;
    min-height: 0;
    padding: 12px 24px;
    overflow-y: hidden;

    .ant-table-wrapper {
      height: 100%;

      .ant-spin-nested-loading {
        height: 100%;

        .ant-spin-container {
          display: flex;
          flex-flow: column nowrap;
          height: 100%;

          .ant-table {
            flex: auto;
            overflow: hidden;

            .ant-table-container {
              display: flex;
              flex-flow: column nowrap;
              height: 100%;

              .ant-table-header {
                flex: none;
              }

              .ant-table-body {
                flex: auto;
                overflow: scroll;
              }
            }
          }

          .ant-table-pagination {
            flex: none;
          }
        }
      }
    }
  }
`;
